export const PATH = '/smartcargas/pool';
export const PAGE_TITLE = 'LoadsPool';
export const PAGE_SUBTITLE = 'ConfirmationManager';
